import React from 'react';
import { Button, Typography, Space } from 'antd';
import { PlusCircleFilled } from '@ant-design/icons';

const { Title, Text } = Typography;

const PageHeader = ({ title, subtitle, icon, onAdd, addLabel = "Add New", canAdd = true, extras }) => {
  return (
    <>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '16px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          {icon && (
            <div style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 24
            }}>
              {icon}
            </div>
          )}
          <div>
            <Title level={3} style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a' }}>
              {title}
            </Title>
            {subtitle && <Text style={{ fontSize: 13, color: '#64748b' }}>{subtitle}</Text>}
          </div>
        </div>
        
        <Space>
          {extras}
          {canAdd && (
            <Button
              icon={<PlusCircleFilled />}
              onClick={onAdd}
              style={{
                background: 'linear-gradient(135deg, #1a56db 0%, #1e429f 100%)',
                border: 'none',
                color: 'white',
                padding: '8px 18px',
                height: 'auto',
                borderRadius: 8,
                fontWeight: 500,
                transition: 'all 0.15s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(26,86,219,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              {addLabel}
            </Button>
          )}
        </Space>
      </div>
      <div style={{ height: 1, background: '#e2e8f0', marginBottom: 24 }} />
    </>
  );
};

export default PageHeader;